export const API_BASE_URL = import.meta.env.PROD
  ? 'https://vantage-api.foober.workers.dev/api/v1'
  : '/api/v1';

export const DATE_RANGES = [
  { label: 'Last 7 days', value: '7d' },
  { label: 'Last 30 days', value: '30d' },
  { label: 'Last 90 days', value: '90d' },
  { label: 'Custom', value: 'custom' },
] as const;

export const DEVICE_TYPES = [
  { label: 'All Devices', value: 'all' },
  { label: 'Desktop', value: 'desktop' },
  { label: 'Mobile', value: 'mobile' },
  { label: 'Tablet', value: 'tablet' },
] as const;

export const HEATMAP_TYPES = [
  { label: 'Click', value: 'click' },
  { label: 'Scroll', value: 'scroll' },
  { label: 'Move', value: 'move' },
  { label: 'Rage Click', value: 'rage' },
] as const;

export const SESSION_COLUMNS = [
  'Visitor',
  'Date',
  'Duration',
  'Pages',
  'Entry Page',
  'Device',
  'Country',
  'Tags',
  'Actions',
] as const;

export const NAV_ITEMS = [
  { label: 'Dashboard', path: '/', icon: 'LayoutDashboard' },
  { label: 'Sessions', path: '/sessions', icon: 'Play' },
  { label: 'Heatmaps', path: '/heatmaps', icon: 'Flame' },
  { label: 'Funnels', path: '/funnels', icon: 'Filter' },
  { label: 'Forms', path: '/forms', icon: 'FormInput' },
  { label: 'Errors', path: '/errors', icon: 'AlertTriangle' },
  { label: 'Surveys', path: '/surveys', icon: 'MessageSquare' },
  { label: 'Settings', path: '/settings', icon: 'Settings' },
] as const;

export const DEFAULT_PAGE_SIZE = 25;

export const COLORS = {
  primary: '#6366f1',
  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',
  info: '#3b82f6',
  chart: ['#6366f1', '#8b5cf6', '#a78bfa', '#c4b5fd', '#ddd6fe', '#ede9fe'],
} as const;

export const TOKEN_KEY = 'vantage_token';
export const SITE_KEY = 'vantage_site_id';
